import React, { useMemo } from "react"
import { useDrop } from "react-dnd"
import Event from "../../components/events/Event"
import { get } from "lodash"
import { css } from '@emotion/react'
import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'

export default function DayDropZone({ date, children, onDrop, ...props }) {

    const [{ hover, item }, drop] = useDrop({
        accept: 'event-type',
        drop: onDrop,
        collect: monitor => ({
            hover: monitor.isOver(),
            item: monitor.getItem()
        })
    });

    const fakeEvent = useMemo(
        () =>
            item ? { type: get(item, ["eventType", "entityShortName"]) } : {},
        [item]
    );

    return (
        <SimpleBar
            css={css`height: 100%;`}
            scrollableNodeProps={{
                ref: drop,
                ...props,
            }}
        >
            <div css={css`
                display: grid;
                width: 100%;
                grid-Template-columns: repeat(auto-fill, 3em);
                grid-Template-rows: repeat(auto-fill, 3em);
                grid-gap: 4px;
            `}>
                {children}
                <Event
                    css={css`visibility: ${hover ? 'visible' : 'hidden'}`}
                    event={fakeEvent}
                />
            </div>
        </SimpleBar>
    );
}
